import React, { useState, useEffect } from 'react';
import VenueListingLink from './VenueListingLink';
import { getVenues } from '../../../../../ui-kitchen/src/api/api';
import { listVenuesTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';

const VenueListing = () => {
  const [venueList, setVenueList] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    let ignore = false;
    const fetchVenues = () => getVenues()
      .then((data) => {
        /* istanbul ignore else */
        if (!ignore) {
          const venues = listVenuesTransform(data);
          setVenueList(venues);
        }
      });
    fetchVenues();
    return () => { ignore = true; };
  }, []);

  const onSearchTextChangeHandler = (event) => {
    setSearchText(event.target.value);
  };

  const filterVenues = (venue) => {
    if (!searchText) return true;
    const searchTextLC = searchText.toLowerCase();
    const venueName = venue.name.toLowerCase();
    const venueId = venue.id.toString();
    return venueName.includes(searchTextLC) || venueId.includes(searchTextLC);
  };

  return (
    <>
      <input type="search" name="searchText" value={searchText} onChange={onSearchTextChangeHandler} placeholder="Search by name or id" />
      {venueList.filter(filterVenues).map((venue) => <VenueListingLink {...venue} key={venue.id} />)}
    </>
  );
};

export default VenueListing;
